import RegistrationOffersService from '../../services/RegistrationOffersService/RegistrationOffersService';
import { RegistrationOffersState } from './registrationOffers.types';
import {
  createAsyncThunk,
  createSlice,
  selectMarketingMeta,
  updateMarketingMeta,
  State,
  injectSlice,
  appLogout,
} from '@bonanza-social/toolkit/state';
import { Promotion } from '../../services/RegistrationOffersService/RegistrationOffersService.schemas';

const initialState: RegistrationOffersState = {
  data: [],
  dataState: 'idle',
};

export const fetchRegistrationOffers = createAsyncThunk(
  'registrationOffers/fetch',
  async (_, { dispatch, getState }) => {
    await dispatch(updateMarketingMeta());

    const state = getState() as State;
    const marketingMeta = selectMarketingMeta(state);

    return await RegistrationOffersService.getRegistrationOffers({
      params: {
        promoType: 'Welcome',
        IncludeMultipleWelcome: true,
        ReferralCode: marketingMeta.referral_code,
        UtmCampaign: marketingMeta.utm_campaign,
      },
    });
  },
);

const registrationOffers = createSlice({
  name: 'registrationOffers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRegistrationOffers.pending, (state) => {
      state.dataState = 'pending';
    });
    builder.addCase(fetchRegistrationOffers.fulfilled, (state, action) => {
      state.data = action.payload.items;
      state.dataState = 'fulfilled';
    });
    builder.addCase(fetchRegistrationOffers.rejected, (state) => {
      state.dataState = 'rejected';
    });
    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const withRegistrationOffers = injectSlice({
  reducerPath: 'registrationOffers',
  reducer: registrationOffers.reducer,
});

export const selectRegistrationOffers = withRegistrationOffers.selector(
  (state) => state.registrationOffers.data,
);

export const selectRegistrationOffer = (
  id: Promotion['promotionId'],
  defaultToFirst = false,
) =>
  withRegistrationOffers.selector((state) => {
    const offers = selectRegistrationOffers(state);

    return (
      offers.find((offer) => offer.promotionId === id) ||
      (defaultToFirst ? offers[0] : undefined)
    );
  });

export const selectRegistrationOffersLength = withRegistrationOffers.selector(
  (state) => state.registrationOffers.data.length,
);

export const selectRegistrationOffersDataState =
  withRegistrationOffers.selector(
    (state) => state.registrationOffers.dataState,
  );

export const selectReferralRegistrationOffer = () =>
  withRegistrationOffers.selector((state) => {
    const offers = selectRegistrationOffers(state);

    return offers.find(
      (offer) =>
        (offer.promoType === 'Referral' && offer.subPromoType === 'Generic') ||
        (offer.promoType === 'Welcome' && offer.subPromoType === 'Referral'),
    );
  });

export const selectWelcomeGenericOffers = () =>
  withRegistrationOffers.selector((state) => {
    const offers = selectRegistrationOffers(state);

    return offers.filter(
      (offer) =>
        !(offer.promoType === 'Referral' && offer.subPromoType === 'Generic') &&
        !(offer.promoType === 'Welcome' && offer.subPromoType === 'Referral'),
    );
  });
declare global {
  interface LazyLoadedSlices {
    registrationOffers: ReturnType<typeof registrationOffers.reducer>;
  }
}
